/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */
const data = {
    heading: 'About Cremation',
    banner_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2016/sympathy/cremation-facts.jpg',
    multi_description: [
        {
            content: 'Over the years, cremation has become a standard funeral practice as an alternative to burials. Although cremations have been around since ancient times, in recent years they have become a very common way of memorializing those who have passed, across a wide variety of religions and cultures. In fact, as of 2017 over 50% of Americans choose cremation, surpassing burials as the most common practice. Some countries practice cremation even more, such as Japan who experiences a 99% cremation rate.',
        },
        {
            strong: 'What is Cremation?\n',
            content: 'Often performed in a crematorium, cremations usually consist of the combustion and oxidation of remains from a deceased individual to be stored in cremation urns, or even interred in memorial sites. The cremated remains or bone fragments are commonly referred to as "ashes" and "cremains."',
        },
        {
            strong: 'Common Cremation Practices\n',
            content: 'A comforting thing about cremation is that it allows those who cared for the deceased to remember them in their own special way. Being that cremation urns are used in many different cultures and locations around the world, their design, shape, and look often vary according to cultural differences or personal preferences.',
        },
        {
            content: 'Urns are often tastefully designed and at times may even be decorative in order to be the focal part of a room, so that the deceased is always remembered. While traditional urns are shaped like a vase or box, you can also find ones to represent a particular hobby or interest of the decreased. Some of these designs include sports, animals, or cars. Urns can also be buried or put into mausoleums, benches or gardens.',
        },
        {
            content: 'Many people also opt to spread the remaining ashes after cremation in a special place near and dear to their hearts. Natural sites chosen often include oceans, mountains, lakes, or other places that were significant to the deceased. These places range everywhere from sentimental family vacation spots, to the place of one’s birth.',
        },
        {
            content: 'Cremation jewelry is another way to memorialize loved ones who have passed. This type of jewelry holds a small amount of the deceased’s remains within a decorative keepsake pendant, ensuring that surviving loved ones always have them near.',
        },
        {
            image_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2016/sympathy/man-sitting-on-dock-serene-scene.jpg',
        },
        {
            strong: 'Cremation Customs in Different Religions\n',
            content: 'Many religions have their own views on cremation. Though evolving with the times, Roman Catholicism encourages the entombment or burial of remains, while Hinduism requires a close male relative of the departed to deposit the ashes in the holy river of Ganges. While Orthodox Judaism still forbids cremation, Reform Judaism allows for cremation if the remains are buried. However, many Reformed Jewish cemetery sites require the ashes of the deceased to be placed in a coffin before being buried.',
        },
        {
            strong: 'Cremation Services\n',
            content: 'It may come as a surprise to some that cremation does not mean that a funeral ceremony can’t take place. In fact, many families choose to have a funeral when cremation is opted for instead of a traditional burial. In this case, the family can choose to have a memorial service followed by a cremation or to have the cremation performed before the service.',
        },
        {
            content1: 'Cremation services are no different than other funeral services, except there may not be a visitation, depending on when the cremation is performed. Families of those who are cremated still take great comfort in the presence of loved ones at such a service, as well as in traditional condolences expressed through',
            link_content: 'sympathy floral arrangements',
            link_url: '/allsympathyflowersgifts',
            content2: ', cards, and other tokens of affection and sympathy.',
        },
        {
            image_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2016/sympathy/cremation-urn-with-cremation-wreath-and-candles.jpg',
        },
        {
            strong: 'How to Express Sympathy for Cremations\n',
            content: 'Expressing your sympathy for someone who chooses to have their loved one cremated is similar to how you would express sympathy for someone whose loved one was buried. It’s important to provide support through kind words, and if possible, your physical presence depending on your relationship to those in mourning.',
        },
        {
            content1: 'Be there to listen when a grieving friend or family member needs someone to talk to, however, don\'t try to force someone who is mourning to talk if they don’t want to. Sometimes, your presence alone will be enough to comfort them. Also, a beautiful arrangement of',
            link_content: 'cremation flowers',
            link_url: '/sympathy/cremation-11835',
            content2: '\u00A0can be a nice way of showing someone that you\'re thinking of them during a difficult time of loss.',
        },
        {
            content1: 'If the family has opted to not have a service, you can still express your sympathy with',
            link_content: 'sympathy flowers',
            link_url: '/Sympathy',
            content2: '. Either call a local florist in the recipient\'s area or order flowers online and have them sent with a card expressing your support for the family to the spouse and/or children of the deceased.',
        },
        {
            strong: 'If you found this article helpful, you may also be interested in our other sympathy articles...',
            list: [
                {
                    link_content: 'Commonly Asked Funeral Flower Questions',
                    link_url: '/Sympathy-Commonly-Asked-Questions',
                },
                {
                    link_content: 'Appropriate Flowers for a Funeral',
                    link_url: '/Sympathy-Whats-Appropriate',
                },
                {
                    link_content: 'Sympathy & Funeral Etiquette in Different Religions',
                    link_url: '/Sympathy-Sympathy-Etiquette',
                },
                {
                    link_content: 'How to Comfort the Grieving',
                    link_url: '/Sympathy-Comforting-the-Grieving',
                },
                {
                    link_content: 'What to Write in a Sympathy Card',
                    link_url: '/sympathy-article-card-message-suggestions',
                },
            ],
        },
    ],
    related_articles: {
        heading: 'Related Articles',
        articles: [
            {
                link: 'https://pwa.www.1800flowers.com/Sympathy-Sympathy-Etiquette',
                image_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2018/sympathy/sympathy-etiquette-thumbnail.jpg',
                title: 'Sympathy Etiquette',
            },
            {
                link: 'https://pwa.www.1800flowers.com/sympathy-sandra-magsamen-memorial-ideas',
                image_url: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2017/sympathy/sympathy-funeral-music-article-1.jpg',
                title: 'Sandra Magsamen\nMemorial Ideas',
            },
        ],
    },
};

export default data;
